import { Checkbox, TableBody, TableCell } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import CustomHeading from '../../components/CustomHeading'
import CustomPagination from '../../components/CustomPagination'
import ConfirmDialog from '../../components/Dialog/ConfirmDialog'
import Layout from '../../components/Layout'
import CustomTable from '../../components/Table/CustomTable'
import CustomTableHeading from '../../components/Table/CustomTableHeading'
import CustomTableRow from '../../components/Table/CustomTableRow'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { useLeadSource } from '../../hooks/CompanyConfiguration/useLeadSource'

import { formatDate, handleSelectAllClick, handleSelectedItem, isSelected, paginatedData, paginatePages, ROUTES } from '../../shared/constants'
import { itemsPerPage } from '../../shared/data'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import { useHistory } from 'react-router'
import { NoDataFound } from '../../components/NoDataFound'
import Loader from '../../components/Loader'

function LeadSources() {
  const { leadSources } = useContext(ConfigurationContext)
  const { getAllLeadSource, deleteLeadSource, deleteManyLeadSource, BulkUpload, loading, paginate } = useLeadSource()

  const [searchQuery, setSearchQuery] = useState('')

  const filterLeadSource = leadSources ? leadSources.filter((leadSource) => leadSource && leadSource.name && leadSource.name.toLowerCase().includes(searchQuery.toLowerCase())) : []
  const [page, setPage] = React.useState(1)

  const [selected, setSelected] = React.useState([])
  const [deleteDialog, setDeleteDialog] = React.useState(false)
  // const noOfPages = paginate && paginate.totalPage
  const noOfPages = paginatePages(filterLeadSource)
  const handleChange = (event, value) => {
    setPage(value)
  }

  let multipleId = []
  selected.length && selected.map((item) => multipleId.push(item._id))
  const [multipleDeleteDialog, setMultipleDeleteDialog] = React.useState(false)
  const history = useHistory()

  useEffect(() => {
    getAllLeadSource({})
  }, [])

  return (
    <Layout
      heading="LeadSource"
      url={ROUTES.ADD_LEADSOURCE}
      selectedData={selected}
      setDeleteDialog={setDeleteDialog}
      // deleteData={}
      editUrl={`/edit-leadSource/${selected.length && selected[0]._id}`}
      setMultipleDeleteDialog={setMultipleDeleteDialog}
      none
      addnone
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
    >
      <CustomTable>
        {filterLeadSource.length > 0 && (
          <CustomTableHeading
            heading={[
              <Checkbox
                indeterminate={selected.length > 0 && selected.length < filterLeadSource.length}
                checked={filterLeadSource.length > 0 && selected.length === filterLeadSource.length}
                onClick={(event) => handleSelectAllClick(event, filterLeadSource, setSelected)}
              />,
              'name',
              'created date',
              'info',
            ]}
          />
        )}
        <TableBody>
          {!loading &&
            filterLeadSource.length > 0 &&
            paginatedData(filterLeadSource, page).map((item, index) => {
              const isItemSelected = isSelected(item, selected)
              return (
                <CustomTableRow>
                  <TableCell onClick={() => handleSelectedItem(item, selected, setSelected)}>
                    <Checkbox checked={isItemSelected} />
                  </TableCell>

                  <TableCell>{item.name}</TableCell>
                  <TableCell>{formatDate(item.createdAt)}</TableCell>
                  <TableCell>
                    <AiOutlineInfoCircle
                      style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                      // onClick={}
                      onClick={() => history.push(`/view-leadSource/${item._id}`)}
                    />
                  </TableCell>
                </CustomTableRow>
              )
            })}
        </TableBody>
      </CustomTable>
      <ConfirmDialog
        open={deleteDialog}
        handleClose={() => setDeleteDialog(false)}
        name={selected.length === 1 && selected[0].name}
        handleSubmit={() => deleteLeadSource({ leadSourceId: selected[0]._id }, setSelected)}
      />
      <ConfirmDialog
        open={multipleDeleteDialog}
        handleClose={() => setMultipleDeleteDialog(false)}
        // name={selected.length === 1 && selected[0].name}
        handleSubmit={() => deleteManyLeadSource({ leadSourceId: multipleId }, setSelected)}
      />
      {!loading && filterLeadSource.length > 0 && <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />}
      {!loading && !filterLeadSource.length && <NoDataFound />}
      {loading && <Loader />}
    </Layout>
  )
}

export default LeadSources
